import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  Input,
  Label,
  FormGroup,
  Form,
} from "reactstrap";
import { toast } from "react-toastify";
import {
  addTwilioPhone,
  getTwilioPhoneDataById,
  updateTwilioPhone,
} from "model/TwilioPhoneModel";

const TwilioPhoneAddEditModal = ({
  setTwilioPhoneAddEditModalOpen,
  twilioPhoneAddEditModalOpen,
  getTwilioPhoneList,
  itemId,
}) => {
  const [formData, setFormData] = useState({
    title: "",
    status: true,
  });

  const closeModal = () => {
    setTwilioPhoneAddEditModalOpen(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData?.title?.trim()) {
      toast.error("Title is required");
      return;
    }

    const payload = {
      title: formData?.title,
      name: formData?.title,
      phoneNumber: formData?.title,
      status: formData?.status ? "active" : "deactive",
    };

    const response = itemId
      ? await updateTwilioPhone(itemId, payload)
      : await addTwilioPhone(payload);

    if (response?.success) {
      toast.success(response?.message || "Twilio Phone saved successfully");
      getTwilioPhoneList?.();
      closeModal();
    } else {
      toast.error(response?.message || "Unable to save Twilio Phone");
    }
  };

  useEffect(() => {
    const getTwilioPhoneById = async () => {
      if (!itemId) {
        setFormData({ title: "", status: true });
        return;
      }
      const response = await getTwilioPhoneDataById({ Id: itemId });
      const row = response?.data;
      if (!row) return;

      setFormData({
        title: row?.title || row?.name || row?.phoneNumber || "",
        status: row?.status === true || row?.status === "active",
      });
    };
    getTwilioPhoneById();
  }, [itemId]);

  return (
    <Modal
      isOpen={twilioPhoneAddEditModalOpen}
      toggle={closeModal}
      backdrop="static"
      className="modal-full-height"
      centered
    >
      <ModalBody className="p-4" style={{ maxHeight: "95vh", overflowY: "auto" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0">Twilio Phone Number</h5>
          <Button close onClick={closeModal} />
        </div>
        <hr />

        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Title</Label>
            <Input
              type="text"
              name="title"
              placeholder="Enter Twilio Phone"
              value={formData.title}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label>Status</Label>
            <div className="input-box d-flex align-items-center justify-content-between">
              <span className="text-muted">Type</span>
              <div className="d-flex align-items-center">
                <strong className="me-2">{formData.status ? "Active" : "Inactive"}</strong>
                <div className="form-switch">
                  <Input
                    type="switch"
                    name="status"
                    checked={formData.status}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </FormGroup>

          <div className="text-end mt-3">
            <Button color="primary" type="submit">
              {itemId ? "Update" : "Save"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default TwilioPhoneAddEditModal;
